
const CONFIG = require(`@conf/${APP_ENV}/public.js`);

export default CONFIG as guesthouse.PublicConfig;
